import { useEffect, useState } from "react";

/**
 * Trails `value` by `delay` ms. Used for search boxes that drive a server
 * query: without it every keystroke is a request, and the responses can land
 * out of order and show results for a prefix of what was typed.
 */
export default function useDebounced(value, delay = 350) {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return settled;
}
